export const LEARNER_FEEDBACK = 'learner-feedback';
export const LEARNER_ACTIVITY = 'learner-activity';
export const ENROLLMENTS = 'enrollments';
export const COMPLETIONS = 'completions';
export const INDUSTRY_BENCHMARKS = 'industry-benchmarks';
export const UTILIZATION = 'utilization';
export const UTILIZATION_LICENSES = 'utilization-licenses';
export const SKILLS_DISTRIBUTION = 'skills-distribution';
export const SKILLS_DEVELOPMENT = 'skills-development';
export const SKILLS_GROWTH = 'skills-growth';
export const LEARNING_EFFORT = 'learning-effort';
export const INDUSTRY_BENCHMARK = 'industry-benchmark';
export const SKILL_OVERVIEW = 'skill-overview';
export const LEARNING_PATHS = 'learning-paths';
